import { Button } from '@mui/material'
import React from 'react'
import firebase from 'firebase/compat/app';
import { auth } from './firebase.js'
import GoogleIcon from '@mui/icons-material/Google';


const SignIn = () => {

    function signInWithGoogle() {
        const provider = new firebase.auth.GoogleAuthProvider()
        auth.signInWithPopup(provider)
    }

  return (
    <div style={{margin: "10px",
      display: "flex",
  }}>
        <GoogleIcon sx={{ width: 50, height: 50 }}/>
        <Button fontSize="medium" onClick={signInWithGoogle}>Sign In With Google</Button>
    </div>
  )
}

export default SignIn